export default "__VITE_ASSET__Biq822t2__"